import React from 'react';
import type { GroupContext } from '../types';

interface ExtensionCapacityPageProps {
  t: (key: string, params?: Record<string, any>) => string;
  groupContext: GroupContext;
  onTerminateSession: () => void;
}

const ExtensionCapacityPage: React.FC<ExtensionCapacityPageProps> = ({
  t,
  groupContext,
  onTerminateSession,
}) => {
  const activeMembers = (groupContext.members || []).filter(m => m.active).length;
  const maxTotalGuests = groupContext.group.maxTotalGuests ?? activeMembers;

  return (
    <div className="info-page">
      <div className="info-box">
        <p className="info-title">
          {t('extensionCapacityTitle') || 'Gruppe bereits voll belegt'}
        </p>
        <p>
          {t('extensionCapacityIntro')
            || 'Diese Gruppe hat die maximale Teilnehmerzahl bereits erreicht. Eine Erweiterung ist nicht mehr möglich.'}
        </p>
        <ul className="info-list">
          <li>
            {t('extensionCapacityCurrent', { current: activeMembers, max: maxTotalGuests })
              || `Aktive Gruppenmitglieder: ${activeMembers}/${maxTotalGuests}`}
          </li>
          <li>
            {t('extensionCapacityNoAction')
              || 'Bitte beenden Sie die Sitzung. Für weitere Änderungen wenden Sie sich an das Veranstaltungsteam.'}
          </li>
        </ul>
        <button className="login-button info-continue-btn" onClick={onTerminateSession}>
          {t('extensionCapacityTerminate') || 'Sitzung beenden'}
        </button>
      </div>
    </div>
  );
};

export default ExtensionCapacityPage;
